import { E2eeCache } from '@gem/modules/cache';

import Entities from 'STORE';

export const e2eeCache = new E2eeCache({
  appVersion: Entities.App.version,
});
